document.addEventListener('DOMContentLoaded', () => {

  // *************************
  // Collection infinite loading
  // Load more products with the load more button beneath the pagination on a PLP
  // *************************
  function loadMorePosts() {

    const loadMoreURL = document.querySelector('[data-load-more] a').getAttribute('href');
    const pagingEl = document.querySelector('[data-paging]');

    // add display none check after
    if (loadMoreURL.length > 0) {
      // Hide the paging element while we load in the new content
      pagingEl.classList.add('opacity-0');
      fetch(loadMoreURL)
      .then(response => response.text())
      .then(responseText => {
        // Parse the response text
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Get the product cards from the next page
        const filteredData = html.querySelectorAll('[data-blog-list] [data-blog-item]');
        // Append these cards to the main collection list
        filteredData.forEach(item => {
          document.querySelector('[data-blog-list]').append(item);
        });

        // Update the paging area
        const pagingData = html.querySelector('[data-paging]');
        
        if (pagingData){
          pagingEl.innerHTML = pagingData.innerHTML;
        } else {
          pagingEl.classList.add('hidden');
        }

        // Reveal the paging element again
        pagingEl.classList.remove('opacity-0');

      })
      .catch(e => {
        console.error(e);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const loadMoreButton = event.target.closest('[data-load-more] a');
    if (loadMoreButton) {
      event.preventDefault();
      loadMorePosts();
      return false;
    }
  });


  document.addEventListener('click', (event) => {

    // clicked on a product card from the PLP?
    const dataEl = event.target.closest('[data-blog-item]');
    if (dataEl) {
      // get the page content
      let blogGrid = document.getElementById("blogGridContainer").innerHTML;
      
      // get the current location and scroll
      const 
        location = window.location.href,
        scroll = window.scrollY;
        
      window.history.pushState({data: blogGrid, name: 'blog-grid', scroll: scroll}, '', location);
      
    }
  });

  if (window.history && window.history.pushState) {
    if (window.history.state && (window.history.state.name == 'blog-grid') && document.getElementById("blog-grid")) {
      document.getElementById("blogGridContainer").innerHTML = window.history.state.data;
    }
  }



});